import script from "./greet.vue?vue&type=script&setup=true&lang=js"
export * from "./greet.vue?vue&type=script&setup=true&lang=js"

import "./greet.vue?vue&type=style&index=0&id=088cb57e&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ydsk-ph-h5-bankv3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-088cb57e"]])

export default __exports__